import { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
function FormInputIcon({
    label,
    name,
    errors,
    type = "text",
    required = false,
    value,
    defaultValue = "",
    placeholder = "",
    textarea = false,
    maxLengthText = "max length 1000 character",
    disabled = false,
    showHeaderLabel = true,
    icon,
    validation = {},
    isShowHideIcon = false,
    showPassword = false,
    onClickShowHide,
    autoComplete
}) {
    const InputTag = textarea ? "textarea" : "input";
    return (
        <Fragment>
            {
                showHeaderLabel && (
                    <label className="form-label fw-bold fs-9 mb-1 text-body-emphasis" htmlFor={name}>
                        {label.replace("Assign", "")} {required && <span className="text-danger">*</span>}
                    </label>
                )
            }
            <div className="position-relative">
                {icon && (
                    <FontAwesomeIcon
                        className="position-absolute fs-9 text-body-tertiary"
                        icon={icon}
                        style={{ top: textarea ? '12px' : '50%', transform: textarea ? 'none' : 'translateY(-50%)', left: '14px' }}
                    />
                )}
                <InputTag
                    id={name}
                    disabled={disabled}
                    type={type}
                    className={`form-control ${textarea ? "textarea-h-130" : ""} ${icon ? "ps-5" : "ps-3"} ${isShowHideIcon ? "pe-5" : ""}`}
                    {...validation}
                    {...(value !== undefined ? { value } : { defaultValue })}
                    placeholder={placeholder || label}
                    autoComplete={autoComplete}
                />
                {isShowHideIcon && !disabled && (
                    <button
                        type="button"
                        className="btn px-3 position-absolute top-0 end-0 fs-7 text-body-tertiary h-100 d-flex align-items-center"
                        onClick={() => onClickShowHide((prev) => !prev)}
                    >
                        <FontAwesomeIcon
                            icon={showPassword ? faEyeSlash : faEye}
                            className="fs-8"
                        />
                    </button>
                )}
            </div>
            <div className="d-flex justify-content-between mt-1">
                <span>
                    {errors?.[name] && (
                        <span className="fw-bold text-danger" style={{ fontSize: '0.78rem' }}>
                            {errors?.[name].message}
                        </span>
                    )}
                </span>
                {maxLengthText && <span className="fw-bold text-body-tertiary" style={{ fontSize: '0.78rem' }}>{maxLengthText}</span>}
            </div>
        </Fragment>
    );
}
export default FormInputIcon;